import React from 'react';
import { Check } from 'lucide-react';
import type { SnackbarState } from '../types';

interface SnackbarProps {
  snackbar: SnackbarState;
  onClose: () => void;
}

const Snackbar: React.FC<SnackbarProps> = ({ snackbar, onClose }) => {
  if (!snackbar.open) return null;

  const severityClasses = {
    success: 'bg-success text-white',
    error: 'bg-destructive text-white',
    info: 'bg-primary text-white'
  };

  return (
    <div className={`fixed bottom-8 left-1/2 transform -translate-x-1/2 px-6 py-3 rounded-lg shadow-lg flex items-center gap-2 z-50 ${severityClasses[snackbar.severity]}`}>
      <span>{snackbar.message}</span>
      <button onClick={onClose} className="ms-2 text-white/80 hover:text-white">
        &times;
      </button>
    </div>
  );
};

interface CopiedToastProps {
  show: boolean;
  t: (key: string) => string;
}

export const CopiedToast: React.FC<CopiedToastProps> = ({ show, t }) => {
  if (!show) return null;

  return (
    <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 bg-success text-white px-6 py-3 rounded-lg shadow-lg flex items-center gap-2 z-50">
      <Check className="w-5 h-5" />
      <span>{t('Link copied to clipboard!')}</span>
    </div>
  );
};

export default Snackbar;
